<template>
    <div v-if="suratJalan">
        <b-card class="m-0" no-body>
            <b-card-header class="d-flex justify-content-between align-items-center">
                <h5 class="modal-title">{{ suratJalan.id ? 'Informasi' : 'Konfirmasi' }} Surat Jalan</h5>
            </b-card-header>
            <b-card-body>
                <div class="table-responsive">
                    <table class="table table-borderless">
                        <tr>
                            <th class="fit-column">Tipe Surat</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ camelCase(type, '_', ' ') }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Tanggal Berangkat</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ formatDate(suratJalan.suratable.tanggal_berangkat) }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Total Bobot</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ formatNumber(suratJalan.suratable.bobot_berangkat) }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Admin Gudang</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ suratJalan.admin_gudang }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Sopir</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ suratJalan.driver }}</th>
                        </tr>
                        <tr v-if="type == 're_dry'">
                            <th class="fit-column">Vendor</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ suratJalan.vendor }}</th>
                        </tr>
                    </table>
                </div>
            </b-card-body>
            <b-card-footer class="d-flex flex-row-reverse">
                <button :disabled="isLoading" v-if="isKonfirmasi" @click="isLoading = true; $emit('koreksi')" type="button" class="btn btn-secondary">Koreksi</button>
                <button :disabled="isLoading" v-if="isKonfirmasi" @click="isLoading = true; $emit('ok')" type="button" class="btn btn-primary mr-2"><i class="fas fa-print"></i> Print</button>
                <button :disabled="isLoading" v-if="!isKonfirmasi" @click="$emit('cancel')" type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button :disabled="isLoading" v-if="!isKonfirmasi" @click="print" type="button" class="btn btn-primary mr-2"><i class="fas fa-print"></i> Print</button>
            </b-card-footer>
        </b-card>
    </div>
</template>

<script>
export default {
    name: "surat-jalan-viewer",

    props: {
        isKonfirmasi: {
            type: Boolean,
            default: false,
        },

        value: {
            type: Object,
            default: () => {},
        }
    },

    components: {
    },

    data() {
        return {
            suratJalan: null,
        }
    },

    created() {
    },

    mounted() {
        if (this.value) {
            this.initSuratJalan();
        }
    },

    computed: {
        type() {
            return this.suratJalan.type && this.suratJalan.type.value ? this.suratJalan.type.value : this.suratJalan.type;
        },
    },

    watch: {
        value() {
            this.initSuratJalan();
        }
    },

    methods: {
        initSuratJalan() {
            let self = this;

            self.suratJalan = Object.assign({}, self.value);
        },

        print() {
            let self = this;

            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            newIframe.src = '/surat-jalans/print/'+self.suratJalan.id;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
                self.$emit('cancel');
            }
        },
    },
}
</script>
<style>
.fit-column {
    width: 0.1%;
    white-space: nowrap;
}

th, td {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
}
</style>
